import { type MCPServerInfo } from '../../types';

const RedisServer: MCPServerInfo = {
  serverId: 'REDIS',
  name: 'Redis',
  slug: 'redis',
  description: 'Access to Redis database operations.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/redis:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['redisHost', 'redisPort'],
    properties: {
      redisHost: {
        type: 'string',
        description: 'Redis hostname',
        sensitive: false
      },
      redisPort: {
        type: 'integer',
        description: 'Redis port',
        sensitive: false
      },
      redisUsername: {
        type: 'string',
        description: 'Redis username',
        sensitive: false
      },
      redisPassword: {
        type: 'string',
        description: 'Redis password',
        sensitive: true
      },
      redisSsl: {
        type: 'boolean',
        description: 'Enable SSL connection',
        sensitive: false
      },
      redisCa_path: {
        type: 'string',
        description: 'CA certificate',
        sensitive: false
      },
      redisSsl_keyfile: {
        type: 'string',
        description: 'SSL key file',
        sensitive: true
      },
      redisSsl_certfile: {
        type: 'string',
        description: 'SSL certificate',
        sensitive: false
      },
      redisCert_reqs: {
        type: 'string',
        description: 'SSL certificate requirements',
        sensitive: false
      },
      redisCa_certs: {
        type: 'string',
        description: 'CA certificates',
        sensitive: false
      },
      redisCluster_mode: {
        type: 'boolean',
        description: 'Enable Redis cluster mode',
        sensitive: false
      }
    }
  }
};

export default RedisServer;
